import React from 'react';

const ValueProposition = () => (
  <div className="w-full flex h-screen">
    <p className="m-auto">Value Proposition Page</p>
  </div>
);

export default ValueProposition;
